import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [companyInfo, setCompanyInfo] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCursorHover, setIsCursorHover] = useState(false);
  const [cursorLabel, setCursorLabel] = useState("");
  const [activeSection, setActiveSection] = useState("home");
  const [scrollProgress, setScrollProgress] = useState(0);

  const toggleMenu = useCallback(() => setIsMenuOpen((p) => !p), []);
  const closeMenu = useCallback(() => setIsMenuOpen(false), []);
  const finishLoad = useCallback(() => setIsLoading(false), []);

  // Apply light theme on mount
  useEffect(() => {
    if (typeof window !== "undefined") {
      document.documentElement.setAttribute("data-theme", "light");
      document.documentElement.classList.remove("dark");
      document.documentElement.classList.add("light");
    }
  }, []);

  const value = {
    isLoading,
    setIsLoading,
    finishLoad,
    isMenuOpen,
    setIsMenuOpen,
    toggleMenu,
    closeMenu,
    isCursorHover,
    setIsCursorHover,
    cursorLabel,
    setCursorLabel,
    activeSection,
    setActiveSection,
    scrollProgress,
    setScrollProgress,
    companyInfo,
    setCompanyInfo,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used inside AppProvider");
  return ctx;
}

export default AppContext;
